export default "__VITE_ASSET__18b7202f__"